import { Controller } from "@hotwired/stimulus"

// Off-canvas sidebar drawer for mobile.
// On desktop (md+) the sidebar is static; these actions are no-ops visually
// because Tailwind's md: variants pin it open.
export default class extends Controller {
  static targets = ["panel", "backdrop"]

  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
    document.addEventListener("keydown", this.closeOnEscape)
    // Start closed on every (re)connect, e.g. after Turbo navigation.
    this.close()
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  toggle() {
    if (this.panelTarget.classList.contains("-translate-x-full")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.panelTarget.classList.remove("-translate-x-full")
    this.panelTarget.classList.add("translate-x-0")
    if (this.hasBackdropTarget) this.backdropTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden", "md:overflow-auto")
  }

  close() {
    this.panelTarget.classList.add("-translate-x-full")
    this.panelTarget.classList.remove("translate-x-0")
    if (this.hasBackdropTarget) this.backdropTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden", "md:overflow-auto")
  }

  // Close when a navigation link inside the drawer is tapped (mobile).
  closeOnNavigate(event) {
    if (event.target.closest("a")) this.close()
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close()
  }
}
